import { useOffers } from '../../context/OffersContext';
import { offerBadgeText } from '../../utils/offerMatch';

/** "Buy 1 Get 1 Free" on a product card when an automatic offer covers the product. */
const OfferBadge = ({ product }) => {
  const { offersFor } = useOffers();
  const offer = offersFor(product)[0];
  if (!offer) return null;
  return (
    <span className="badge bg-primary text-white text-[10px] px-2 py-0.5"
      data-testid="offer-badge">
      {offerBadgeText(offer)}
    </span>
  );
};

export default OfferBadge;
